import { ChatTypeEnum } from "@/apis/model/ChatTypeEnum";
import { assert } from "@/common/assert";
import { FHTChatId } from "./FHTChatId";
export var LeancloudOfficialMessageType;

(function (LeancloudOfficialMessageType) {
  //see https://leancloud.cn/docs/realtime_v2.html#hash939050100
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["TextMessage"] = -1] = "TextMessage";
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["ImageMessage"] = -2] = "ImageMessage";
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["AudioMessage"] = -3] = "AudioMessage";
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["VideoMessage"] = -4] = "VideoMessage";
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["LocationMessage"] = -5] = "LocationMessage";
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["FileMessage"] = -6] = "FileMessage";
  LeancloudOfficialMessageType[LeancloudOfficialMessageType["RecallMessage"] = -127] = "RecallMessage";
})(LeancloudOfficialMessageType || (LeancloudOfficialMessageType = {}));

export var FhtLeancloudCustomMessageType;

(function (FhtLeancloudCustomMessageType) {
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["BusinessEmoji"] = 1] = "BusinessEmoji";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["TopicPost"] = 2] = "TopicPost";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["NameCard"] = 3] = "NameCard";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["CompanyCard"] = 4] = "CompanyCard";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["Product"] = 5] = "Product";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["Meetup"] = 6] = "Meetup";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["Forward"] = 7] = "Forward";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["DataSync"] = 99] = "DataSync";
  FhtLeancloudCustomMessageType[FhtLeancloudCustomMessageType["ChatRoomStatus"] = 100] = "ChatRoomStatus";
})(FhtLeancloudCustomMessageType || (FhtLeancloudCustomMessageType = {}));

export function shouldHandleFhtChatId(chatId) {
  assert(chatId instanceof FHTChatId, "invalid chatId");
  return chatId.chatType === ChatTypeEnum.Tourist || chatId.chatType === ChatTypeEnum.Personal;
}
export var VoidUrl = "#";